export const phoneNumber = "+1 (438) 228-1460";
export const emailAddress = "info@kenzsoft.com";
export const companyName = "Kenz Software";
export const websiteAddress = "https://www.kenzsoft.com";

// eslint-disable-next-line
export const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export const amazonImageUrl = "https://kenz-8a80d.s3.ca-central-1.amazonaws.com/images";